import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {Subscription} from 'rxjs';
import {Attribute, AttributeOption} from '../../../products/models/attribute';
import * as fromProducts from '../../../products/reducers';
import {I18nDictionaryComponent} from '../../../shared/components/i18n-dictionary/i18n-dictionary.component';
import {TitleService} from '../../../shared/services/title.service';
import '../../../shared/components/navigable';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LandingPageComponent implements OnInit, AfterViewInit, OnDestroy, Navigable {
    static readonly COMPONENT_ID = 'LandingPageComponent';
    static readonly CATEGORY_ATTRIBUTE_CODE = 'product_category';

    readonly titleTextId = 'categories-page_title';
    readonly siteTitleTextId = 'categories-page_site-title';
    readonly landingDescriptionId = 'categories-page_landing-description'
    readonly shopButtonId = 'categories-page_shop-button';
    readonly titleNewsletterId = 'categories-page_title-newsletter';
    readonly descriptionNewsletterId = 'categories-page_description-newsletter';

    form: FormGroup = new FormGroup({
        email: new FormControl('',
            [
                Validators.email,
                Validators.required
            ]
        )
    });

    @ViewChild(I18nDictionaryComponent, {static: true})
    i18nDictionary: I18nDictionaryComponent;

    categoryAttribute: Attribute;

    private categoryAttribute$: Subscription;

    constructor(private ref: ChangeDetectorRef,
                private titleService: TitleService,
                private store: Store<fromProducts.State>) {
    }

    ngOnInit(): void {
        this.categoryAttribute$ = this.store.pipe(
            select(fromProducts.getAttributeByCode(LandingPageComponent.CATEGORY_ATTRIBUTE_CODE))
        ).subscribe(a => {
            this.categoryAttribute = a;
            this.ref.detectChanges();
            console.log('reload category attribute', a);
        });
    }

    ngAfterViewInit(): void {
        this.titleService.setTitle(this.i18nDictionary.get(this.siteTitleTextId));
        // detect changes here to reinit page.
        // I18nDictionary component won't be ready before this method is called.
        this.ref.detectChanges();
    }

    ngOnDestroy(): void {
        this.categoryAttribute$.unsubscribe();
    }

    getId(): string {
        return LandingPageComponent.COMPONENT_ID;
    }

    submit() {
        if (this.form.valid) {
            const f = document.createElement('form');
            f.target = 'view';
            f.method = 'POST';
            f.action = 'https://heringberlin.us16.list-manage.com/subscribe/post?u=b41ff397e5cdad2538a13123c&id=d20aad8d1c';
            const params = {
                'EMAIL': this.form.get('email').value,
                'subscribe': 'Subscribe'
            };

            for (const i in params) {
                if (params.hasOwnProperty(i)) {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = i;
                    input.value = params[i];
                    f.appendChild(input);
                }
            }

            document.body.appendChild(f);
            f.submit();
            window.open('', 'view');
        }
    }

    getCatalogUrl(categoryOptionId: number): string {
        const attributeOption = this.getCategoryOption(categoryOptionId);
        if (attributeOption == null) {
            return null;
        }

        return `/products/filter/${LandingPageComponent.CATEGORY_ATTRIBUTE_CODE}:${attributeOption.value}`;
    }

    getCategoryOption(id: number): AttributeOption {
        if (this.categoryAttribute == null || this.categoryAttribute.options == null) {
            return null;
        }

        const categoryOptions = this.categoryAttribute.options.filter(o => o.label.trim().length > 0);
        if (categoryOptions.length <= id) {
            return null;
        }

        return categoryOptions[id];
    }
}
